import { FC, ReactNode } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

/**
 * @param isLogin boolean ログインしているかどうか
 * @param redirectPath ログインしていない場合のリダイレクト先 ない場合はGlobalHomeへ
 * @returns
 */
export const GuestOnlyRoute: FC<
  { isLogin: boolean; redirectPath: string; element: ReactNode } & RouteProps
> = ({ isLogin, redirectPath, element, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        // ログインしていれば、リダイレクト
        if (isLogin)
          return (
            <Redirect
              to={{ pathname: redirectPath, state: { from: location } }}
            />
          )
        return element
      }}
    />
  )
}
